import { Index } from "./Index/index";
import { Pro } from "./Pro";

export const Account = {
  Index,
  Pro,
};
